<template>
    <div class="photoShow flex-center-xy" v-if="showPic" @touchmove.prevent @mousewheel.prevent>
      <img src="../../../assets/certificate-icon/close-icon.png" alt="" class="close"  @click="noShow">
      <!-- 证书 -->
      <canvas ref="headCanvas" style="position: absolute;height: 0; width: 0;opacity: 0;"></canvas>
      <div
        class="certificate-box"
        ref="canvasImg"
        id="printPic"
        :style="{width: certificateInfo.width, height: certificateInfo.height}">
        <img :src="certificateInfo.url" :style="{width: certificateInfo.width, height: certificateInfo.height}" class="bg"/>
        <div v-for="(item,index) in certificateInfo.style" :key="index" :style="item.css" :class="[item.key=='two'?'content':'',]" v-html="certificateInfo[item.key]"></div>
      </div>
      <p class="time">查询时间：{{ certificateInfo.date }}</p>
      <div class="btn">
        <p v-print="'#printPic'">打印</p>
        <p @click="saveImage('canvasImg', 'certificate')">下载</p>
      </div>
    </div>
</template>

<script>
import html2canvas from 'html2canvas'
import { queryCertificateByNum } from '@/api/certificate'
export default {
  props: {
    url: {
      type: String
    },
    showPic: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object
    }
  },
  data () {
    return {
      certificateInfo: {}
    }
  },
  watch: {
    showPic(val) {
      if (val) {
        this.getCertificateInfo()
      }
    }
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    getCertificateInfo() {
      queryCertificateByNum({
        num: this.info.graduationNumber
      }).then(res => {
        const { code, data } = res
        if (code === 0) {
          this.certificateInfo = data
          this.certificateInfo.style = this.certificateInfo.style && JSON.parse(this.certificateInfo.style)
          this.certificateInfo.style.forEach(item => {
            this.certificateInfo[item.key] = this.certificateInfo[item.key].replace(/\[/g, '<span style="border-bottom: 1px solid #000;padding:0 2px">')
            this.certificateInfo[item.key] = this.certificateInfo[item.key].replace(/\]/g, '</span>')
          })
          this.ImageToBase64()
        }
      })
    },
    noShow () {
      this.$emit('showPic', this.info)
    },
    // 将网络图片转化为Base64
    ImageToBase64() {
      const vm = this
      // 一定要设置为let，不然图片不显示，下面解释↓
      const image = new Image()

      // 解决跨域问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.src = this.certificateInfo.url + '?time=' + new Date()

      // image.onload为异步加载
      image.onload = () => {
        const canvas = vm.$refs.headCanvas
        const context = canvas.getContext('2d')
        canvas.width = image.width
        canvas.height = image.height
        context.drawImage(image, 0, 0, image.width, image.height)
        const dataurl = canvas.toDataURL('image/png')
        // 得到64位格式
        this.certificateInfo.url = dataurl
      }
    },
   // 图片格式转换方法
    dataURLToBlob(dataurl) {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?)/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    // 点击方法
    saveImage(divText, imgText) {
      const canvasID = this.$refs[divText]
      const that = this
      const a = document.createElement('a')
      html2canvas(canvasID).then(canvas => {
        const dom = document.body.appendChild(canvas)
        dom.style.display = 'none'
        a.style.display = 'none'
        document.body.removeChild(dom)
        const blob = that.dataURLToBlob(dom.toDataURL('image/png'))
        a.setAttribute('href', URL.createObjectURL(blob))
        // 这块是保存图片操作  可以设置保存的图片的信息
        a.setAttribute('download', imgText + '.png')
        document.body.appendChild(a)
        a.click()
        URL.revokeObjectURL(blob)
        document.body.removeChild(a)
      })
    }
  },
  components: {

  }
}
</script>

<style scoped lang="scss">
@import url("../../../assets/font.css");
@media print {
  @page {
    size: auto; /* auto is the initial value */
    margin: 0; /* this affects the margin in the printer settings */
  }
  .certificate-box {
    transform: scale(2);
    margin: 300px auto;
  }
  body {
    height: auto !important;
  }
}
  .certificate-box {
    position: relative;
    font-family:'sc-regular';
    &>div {
      position: absolute;
    }
    .bg {
      position: absolute;
      top: 0;
      left: 0;
    }
    .content {
      text-indent:2em;
      padding-left: 60px;
      padding-right: 60px;
      line-height: 2;
      letter-spacing:1px;
      text-align: left;
      font-family: 'sc-regular';
    }
  }
  .flex-center-xy {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .photoShow {
    width: 100%;
    height: 100%;
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .4);
    z-index: 1000;
    .pic {
      height: 500px;
    }
    .close {
      position: absolute;
      right: 24%;
      top: 8%;
      width: 34px;
      height: 34px;
      cursor: pointer;
    }
  }
  p {
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    margin-top: 45px;
  }
  .btn {
    width: 335px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    p {
      cursor: pointer;
    }
  }
</style>
